import { FixedNumber } from "ethers"
import { useUserFerroBar } from "src/state/xFer/hooks"

/**
 *
 * @returns xFER : FER rate
 */
const useXFerRate = (): FixedNumber => {
  const { barData } = useUserFerroBar()
  const { stakedBalance, totalSupply } = barData

  const stakedBalanceFN = FixedNumber.from(stakedBalance)
  const totalSupplyFN = FixedNumber.from(totalSupply)

  return stakedBalance.gt(0) && totalSupply.gt(0)
    ? stakedBalanceFN.divUnsafe(totalSupplyFN)
    : FixedNumber.from(1)
}

export default useXFerRate
